export  const authActions = {
    setRole : 'SET_ROLE',
    login : 'LOGIN',
    logout : 'LOGOUT'
}